import FeedbackForPotentialUsers from "@/components/feedback-for-potential-users";
import NegativeVouchFeedback from "@/components/negative-vouch-feedback";
import NoIndex from "@/components/no-index";
import type { Vouchee, Voucher } from "@/lib/types";
import { Navigate, useLocation, useParams } from "react-router";

const VouchComplete = () => {
  const location = useLocation();
  const isNegative = location.state?.negative === true;

  const vouchee = location.state?.vouchee as Vouchee | undefined;
  const voucher = location.state?.voucher as Voucher | undefined;

  const { vouchId } = useParams();
  if (!location.state) return <Navigate to={`/vouch/${vouchId}`} replace />;

  return (
    <>
      <NoIndex />
      <section className="vouch-gradient hero">
        <div className="animate-screen relative z-10 mx-auto flex max-w-4xl flex-col gap-5 px-6 py-24 sm:gap-10">
          {isNegative ? (
            <NegativeVouchFeedback vouchee={vouchee} />
          ) : (
            <FeedbackForPotentialUsers vouchee={vouchee} voucher={voucher} />
          )}
        </div>
      </section>
    </>
  );
};

export default VouchComplete;
